module.exports = __webpack_public_path__ + "static/media/empty-banner.cec9b09d.svg";